import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import ShowMoreText from 'react-show-more-text';
import Tip from '../../../../../../shared/tip';
import { mentionMissingImageTip } from '../../consts';
import FeaturedWiresContext from '../context';
import { useDeleteUnfeatureWire } from '../../../../../../services/wires/featured-wires-service';

const Container = styled.div`
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(50, 50, 71, 0.06), 0px 1px 4px rgba(50, 50, 71, 0.06);
  border: 1px solid #bbcbd8;
  width: 100%;
  margin: 0!important;
  padding: 24px;
  ${props => (props.theme.isMobile ? `
    height: 128px;
  ` : `
    height: 108px;
  `)};

  .tip-container {
    margin-left: -6px;
  }
`;

const HFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 18px;
`;

const Title = styled.div`
  width: 100%;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-size: 15px;
  line-height: 20px;
  color: ${props => props.theme.bodyColor};
  margin-right: 38px;
`;

const RemoveLink = styled.a`
  display: ${props => (props.theme.isSmallMobile ? 'block' : 'inline')};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  &&& {
    color: ${props => props.theme.primaryColor};
  }
`;

export default function MentionMissingImage({ id, slug, title }) {
  const { isMobile } = React.useContext(ThemeContext);
  const { dispatch } = React.useContext(FeaturedWiresContext);
  const [, unfeature] = useDeleteUnfeatureWire(id);

  const remove = e => {
    e && e.preventDefault();
    unfeature().then(() => dispatch({ type: 'removeWire', payload: { slug } }));
  };

  return (
    <Container>
      <HFlex>
        <Title>
          <ShowMoreText lines={isMobile ? 2 : 1} more={null} less={null}>{title}</ShowMoreText>
        </Title>
        <RemoveLink href="#" onClick={remove}>Remove</RemoveLink>
      </HFlex>
      <Tip text={mentionMissingImageTip} largeFont={false} />
    </Container>
  );
}

MentionMissingImage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};
